module.exports = __webpack_public_path__ + "img/google03.63199509.jpg";